// src/shared/sortHeader.js — заглавие на колона, по което се сортира.
//
// Беше <th onClick> — само с мишка; с клавиатура и с екранен четец
// сортирането го нямаше (рецензия 27.10.2026, т. 4.1). Сега в клетката има
// истински бутон (Tab + Enter/интервал), а aria-sort казва посоката.

import { el, clear } from './dom.js';

// attrs — атрибутите на <th> (scope, class); onSort — какво прави натискането.
export function sortTh(attrs, onSort) {
  const btn = el('button', { type: 'button', class: 'sort-btn', onClick: onSort });
  const th = el('th', Object.assign({ scope: 'col', 'aria-sort': 'none' }, attrs || {}), btn);
  th._sortBtn = btn;
  return th;
}

// Надписът и посоката след всяко преначертаване. dir: 'asc' | 'desc' | ''.
export function sortLabel(th, label, dir) {
  const btn = th._sortBtn;
  if (!btn) { th.textContent = label; return; }
  clear(btn);
  btn.appendChild(document.createTextNode(label + (dir === 'asc' ? ' ▲' : dir === 'desc' ? ' ▼' : '')));
  th.setAttribute('aria-sort', dir === 'asc' ? 'ascending' : dir === 'desc' ? 'descending' : 'none');
  btn.setAttribute('aria-label', label + ' — подреди' + (dir === 'asc' ? ' (сега: възходящо)' : dir === 'desc' ? ' (сега: низходящо)' : ''));
}
